import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CustomButton from "../Common/CustomButton";
import StatusDialog from "../Common/StatusDialog";
import CloseIcon from "../Common/CloseIcon";

import { success } from "../../constants/common";

import colors from "../../assets/style/colors";

const styles = {
  dialogPaper1: {
    paddingTop: "24px",
    minWidth: "350px",
    maxWidth: "350px",
  },
  dialogPaper2: {
    paddingTop: "24px",
    minWidth: "750px",
    maxWidth: "750px",
  },
  closeBtn: {
    display: "flex",
    justifyContent: "flex-end",
  },
  title: {
    textTransform: "uppercase",
    color: colors.black87,
    fontWeight: 500,
    textAlign: "center",
  },
};

const CreateDialog = (props) => {
  const { 
    classes, 
    open,
    onClose, 
    dlgTitle,
    typeName,
    creationSuccededMsg,
    creationFailedMsg,
    validForm, 
    values, 
    status, 
    reset, 
    submit } = props;

  return (
    <>
      {status && open ? (
        <StatusDialog
          status={status}
          onClose={() => {
            reset();
            onClose();
          }}
        >
          <div style={{ fontSize: "1.2em" }} className="text-87 text-center">
            <span>{typeName}</span>
            <span className="bold-500">{get(values, ["name"])}</span>
            <span>{status === success ? creationSuccededMsg : creationFailedMsg}</span>
          </div>
        </StatusDialog>
      ) : (
        <Dialog
          open={open}
          classes={{
            paper:
              props.columns === 2 ? classes.dialogPaper2 : classes.dialogPaper1,
          }}
        >
          <Grid container direction="column">
            <Grid item style={{ padding: "0px 24px" }}>
              <Grid container alignItems="center">
                <Grid item xs={2} />
                <Grid item xs className="dialogTitle">
                  {dlgTitle}
                </Grid>
                <Grid item xs={2} className={classes.closeBtn}>
                  <CloseIcon closeFunction={() => onClose()} />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              style={{
                padding: "0px 24px",
                maxHeight: "calc(100vh - 212px)",
                overflow: "auto",
              }}
            >
              {props.children}
            </Grid>
            <Grid item style={{ padding: "24px 0px" }}>
              <Grid container justify="center" alignItems="center">
                <Grid item>
                  <CustomButton color="primary" onClick={() => onClose()}>
                    {I18n.get("site_cancel")}
                  </CustomButton>
                </Grid>
                <Grid item style={{ marginLeft: "10px" }}>
                  <CustomButton
                    variant="contained"
                    color="primary"
                    disabled={!validForm}
                    onClick={submit}
                  >
                    {I18n.get("site_confirm")}
                  </CustomButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Dialog>
      )}
    </>
  );
};

export default withStyles(styles)(CreateDialog);
